import { ModelCache } from 'app/scripts/db/ModelCache';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markRelatedNotificationsRead = function (this: any) {
  for (const notification of ModelCache.all('Notification')) {
    // If notification is related and unread
    if (
      notification.get('unread') &&
      // @ts-expect-error
      !notification.get('data')?.card &&
      // @ts-expect-error
      notification.get('data')?.board?.id === this.model.get('id')
    ) {
      notification.markRead();
    }
  }
};
